<!-- Vaheleht "E-pood"
Idee terve ostukorvi süsteemi loomiseks: https://www.youtube.com/watch?v=444bt-GNufc -->
<template>
  <div class="page-properties">
    <v-dialog v-model="eshopPopupVisible" max-width="560" transition="dialog-bottom-transition">
      <v-card class="eshop-popup-card">
        <div class="eshop-popup-bg" :style="popupBackgroundStyle">
          <v-btn class="eshop-popup-close" icon="mdi-close" @click="closeEshopPopup"></v-btn>
          <div class="eshop-popup-overlay">
            <div class="eshop-popup-text" v-html="eshopPopupMessage"></div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <PageHeader>
      <h1>{{ $t('epood') }}</h1>
      <v-btn v-if="isLoggedIn" color="success" to="/addproduct">lisa +</v-btn>
    </PageHeader>
    <!-- Mobile sort options overlay -->
    <v-dialog v-model="dialog" fullscreen>
      <v-card>
        <v-toolbar style="background-color: white">
          <v-btn icon="mdi-close" @click="dialog = false"></v-btn>
          <v-toolbar-title>{{ $t('sorteeri') }}</v-toolbar-title>
        </v-toolbar>
        <v-sheet class="pa-5">
          <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              variant="outlined"
              :label="$t('otsi')"
          ></v-text-field>
          <div class="text-subtitle-1 font-weight-bold mb-2">{{ $t('filter') }}</div>
          <v-list v-model:opened="mobileOpenedGroups" role="listbox" aria-label="Mobile Category List" density="comfortable" nav>
            <template v-for="entry in groupedCategories" :key="entry.type === 'group' ? `mobile-group-${entry.groupKey}` : `mobile-single-${entry.key}`">
              <v-list-group v-if="entry.type === 'group'" :value="entry.groupKey">
                <template v-slot:activator="{ props }">
                  <v-list-item
                      v-bind="props"
                      class="mobile-category-group-header"
                      prepend-icon="mdi-folder-outline"
                      :title="entry.groupLabel"
                  ></v-list-item>
                </template>

                <v-list-item
                    class="mobile-category-child"
                  active-color="eraklient"
                  :active="isCategoryActive(slugifyCategory(entry.groupKey))"
                    prepend-icon="mdi-view-grid-plus-outline"
                    :title="$t('koik') + ' ' + entry.groupLabel"
                    @click="goToMobileCategory(slugifyCategory(entry.groupKey))"
                ></v-list-item>

                <template v-for="child in entry.items" :key="`mobile-child-${child.key}`">
                  <v-list-item
                      v-if="child.type === 'leaf'"
                      class="mobile-category-child"
                      active-color="eraklient"
                      :active="isCategoryActive(slugifyCategory(child.key))"
                      prepend-icon="mdi-subdirectory-arrow-right"
                      :title="child.value"
                      @click="goToMobileCategory(slugifyCategory(child.key))"
                  ></v-list-item>

                  <v-list-group v-else :value="child.key">
                    <template v-slot:activator="{ props }">
                      <v-list-item
                          v-bind="props"
                          class="mobile-category-child"
                          prepend-icon="mdi-folder-multiple-outline"
                          :title="child.value"
                      ></v-list-item>
                    </template>

                    <v-list-item
                        class="mobile-category-child"
                        active-color="eraklient"
                        :active="isCategoryActive(slugifyCategory(child.key))"
                        prepend-icon="mdi-view-grid-plus-outline"
                        :title="$t('koik') + ' ' + child.value"
                        @click="goToMobileCategory(slugifyCategory(child.key))"
                    ></v-list-item>

                    <v-list-item
                        v-for="subChild in child.items"
                        :key="`mobile-subchild-${subChild.key}`"
                        class="mobile-category-child pl-8"
                        active-color="eraklient"
                        :active="isCategoryActive(slugifyCategory(subChild.key))"
                        prepend-icon="mdi-subdirectory-arrow-right"
                        :title="subChild.value"
                        @click="goToMobileCategory(slugifyCategory(subChild.key))"
                    ></v-list-item>
                  </v-list-group>
                </template>
              </v-list-group>

              <v-list-item
                  v-if="entry.type === 'single'"
                  class="mobile-category-single-header"
                  active-color="eraklient"
                  :active="isCategoryActive(slugifyCategory(entry.key))"
                  prepend-icon="mdi-tag-outline"
                  :title="entry.value"
                  @click="goToMobileCategory(slugifyCategory(entry.key))"
              ></v-list-item>
            </template>
          </v-list>

          <v-btn
              v-if="$route.path.startsWith('/tooted/')"
              block
              variant="outlined"
              color="error"
              prepend-icon="mdi-filter-remove-outline"
              class="mt-3 text-none"
              @click="goToMobileCategory('')"
          >
            {{$t('eemalda_filter')}}
          </v-btn>

          <v-btn
              v-if="isLoggedIn"
              block
              color="success"
              class="mt-3"
              to="/tooted/addeditcategory"
              @click="dialog = false"
          >
            lisa/muuda
          </v-btn>

          <v-divider class="my-4"></v-divider>

          <v-select class="flex-0-0" v-model="sortOption" :items="sortOptions" item-title="text" :label="$t('sorteeri')" menu-icon="mdi-chevron-down" variant="outlined"></v-select>
          <v-select class="flex-0-0" v-model="perPage" :items="perPageOptions" :label="$t('tooteid')" menu-icon="mdi-chevron-down" variant="outlined"></v-select>
        </v-sheet>
      </v-card>
    </v-dialog>
    <div class="mobile-filters flex-column main-content">
      <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" variant="outlined" :label="$t('otsi')"></v-text-field>
      <div class="d-flex justify-space-between align-center">
        <div class="mobile-filters">{{ itemsPerPage }} {{ $t('kuvatud') }} {{ totalProducts }}<span v-if="this.$i18n.locale === 'et'">-st</span></div>
        <v-btn class="mobile-filters" prepend-icon="mdi-sort" variant="outlined" @click="dialog = true">{{ $t('sorteeri') }}</v-btn>
      </div>
    </div>
    <!-- Mobile sort options overlay end -->
    <v-sheet class="d-flex justify-space-between align-center pc-filters">
      <div> {{ itemsPerPage }} {{ $t('kuvatud') }} {{ totalProducts }}<span v-if="this.$i18n.locale === 'et'">-st</span></div>
      <div class="d-flex justify-end">
        <v-text-field class="flex-0-0 w-50" v-model="search" prepend-inner-icon="mdi-magnify" variant="outlined" :label="$t('otsi')"></v-text-field>
        <v-select class="flex-0-0 px-5 w-66" v-model="sortOption" :items="sortOptions" item-title="text" :label="$t('sorteeri')" menu-icon="mdi-chevron-down" variant="outlined"></v-select>
        <v-select class="flex-0-0 w-33" v-model="perPage" :items="perPageOptions" :label="$t('tooteid')" menu-icon="mdi-chevron-down" variant="outlined"></v-select>
      </div>
    </v-sheet>
    <div class="d-flex">
      <div class="sidebar text-left pr-4">
        <v-list v-model:opened="desktopOpenedGroups" role="listbox" aria-label="Product List" class="sidebar-list" density="compact" nav>
          <div class="d-flex">
            <h4 class="text-center w-100">{{ $t('filter') }}</h4>
            <a class="my-auto" v-if="isLoggedIn" :href="'/tooted/addeditcategory'">
              <i class="fa fa-pen-to-square" ></i>
            </a>
          </div>
          <template v-for="entry in groupedCategories" :key="entry.type === 'group' ? `group-${entry.groupKey}` : `single-${entry.key}`">
            <v-list-group v-if="entry.type === 'group'" :value="entry.groupKey">
              <template v-slot:activator="{ props }">
                <v-list-item
                    v-bind="props"
                    role="option"
                    active-color="eraklient"
                  class="py-1 filter-items category-group-header"
                    prepend-icon="mdi-folder-outline"
                    :title="entry.groupLabel"
                ></v-list-item>
              </template>

              <v-list-item
                  role="option"
                  active-color="eraklient"
                  class="py-1 filter-items pl-6 category-child category-all"
                  prepend-icon="mdi-view-grid-plus-outline"
                  :to="`/tooted/${slugifyCategory(entry.groupKey)}`"
                  draggable="false"
                  :title="`Kõik ${entry.groupLabel}`"
              ></v-list-item>

              <template v-for="child in entry.items" :key="`child-${child.key}`">
                <v-list-item
                    v-if="child.type === 'leaf'"
                    role="option"
                    active-color="eraklient"
                    class="py-1 filter-items pl-6 category-child"
                    prepend-icon="mdi-subdirectory-arrow-right"
                    :to="`/tooted/${slugifyCategory(child.key)}`"
                    draggable="false"
                    :title="child.value"
                ></v-list-item>

                <v-list-group v-else :value="child.key">
                  <template v-slot:activator="{ props }">
                    <v-list-item
                        v-bind="props"
                        role="option"
                        active-color="eraklient"
                        class="py-1 filter-items pl-6 category-child"
                        prepend-icon="mdi-folder-multiple-outline"
                        :title="child.value"
                    ></v-list-item>
                  </template>

                  <v-list-item
                      role="option"
                      active-color="eraklient"
                      class="py-1 filter-items pl-10 category-child category-all"
                      prepend-icon="mdi-view-grid-plus-outline"
                      :to="`/tooted/${slugifyCategory(child.key)}`"
                      draggable="false"
                      :title="`Kõik ${child.value}`"
                  ></v-list-item>

                  <v-list-item
                      v-for="subChild in child.items"
                      :key="`subchild-${subChild.key}`"
                      role="option"
                      active-color="eraklient"
                      class="py-1 filter-items pl-10 category-child"
                      prepend-icon="mdi-subdirectory-arrow-right"
                      :to="`/tooted/${slugifyCategory(subChild.key)}`"
                      draggable="false"
                      :title="subChild.value"
                  ></v-list-item>
                </v-list-group>
              </template>
            </v-list-group>

            <v-list-item
                v-if="entry.type === 'single'"
                role="option"
                active-color="eraklient"
                class="py-1 filter-items category-single"
                prepend-icon="mdi-tag-outline"
                :to="`/tooted/${slugifyCategory(entry.key)}`"
                draggable="false"
                :title="entry.value"
            ></v-list-item>
          </template>
        </v-list>

        <v-btn
            v-if="$route.path.startsWith('/tooted/')"
            block
            variant="outlined"
            color="error"
            prepend-icon="mdi-filter-remove-outline"
            class="mt-3 text-none"
            @click="clearCategoryFilter"
        >
          {{$t('eemalda_filter')}}
        </v-btn>
      </div>
      <div>
        <v-divider class="content-divider" vertical></v-divider>
      </div>

      <div class="w-100">
        <div :class="['product', 'mb-5', { 'product--dialog-open': isCartDialogOpen }]">
          <v-card flat :hover="!isCartDialogOpen" :class="['prod-item', 'pa-4', { 'prod-item--dialog-open': isCartDialogOpen }]" v-for="product in paginatedPosts" :key="product.id" @click="handleProductCardClick(product)" draggable="false">
            <div class="product-link">
              <a class="edit-link mx-auto" v-if="isLoggedIn" :href="'/tooted/' + getLinkCat(product) + '/editproduct/' + product.id" @click.stop>
                <i class="fa fa-pen-to-square pa-2"></i>
              </a>
                <div
                  class="product-img"
                    @mouseenter="setImageHover(product.id, true)"
                    @mouseleave="setImageHover(product.id, false)"
                >
                  <div v-if="getProductImages(product).length > 1" class="product-layered-images">
                    <v-img
                        :src="getProductImages(product)[0]"
                        class="carousel-image base-image"
                        :class="{ 'is-inactive': isProductHovered(product.id) }"
                        height="100%"
                        contain
                        eager
                        @click.stop="openProduct(product)"
                    ></v-img>
                    <v-img
                        :src="getProductImages(product)[1]"
                        class="carousel-image hover-image"
                        :class="{ 'is-active': isProductHovered(product.id) }"
                        height="100%"
                        contain
                        eager
                        @click.stop="openProduct(product)"
                    ></v-img>
                  </div>
                  <v-img
                      v-else-if="getProductImages(product).length"
                      :src="getProductImages(product)[0]"
                      class="carousel-image"
                      height="100%"
                      contain
                      @click.stop="openProduct(product)"
                  ></v-img>
                  <img class="d-flex align-center justify-center default-logo" v-else src="../../assets/images/lohnakas.webp" alt="Lohnakas logo" @click.stop="openProduct(product)"/>
              </div>
              <v-card-item class="mb-5 pa-0 text-left">
                <v-card-title class="font-weight-bold"> <span class="head"> {{ getHeader(product) }} </span> </v-card-title>
                <v-card-subtitle>
                  <div class="prices">
                    <p class="price" v-if="hasBottleSizePriceRange(product)">{{ getPriceLabel(product) }}</p>
                    <template v-else>
                      <p class="new-price pr-2" v-if="product.new_price"> {{ product.new_price }}€</p>
                      <p class="old-price" v-if="product.new_price"> {{ product.price }}€</p>
                      <p v-if="!product.new_price"> {{ product.price }}€</p>
                    </template>
                  </div>
                </v-card-subtitle>
                <v-card-text class="pa-0">
                  <div class="product-category-text" v-if="getProductCategoryGroups(product).length">
                    <div
                      class="product-category-group"
                      v-for="(group, groupIndex) in getProductCategoryGroups(product)"
                      :key="`product-cat-group-${product.id}-${groupIndex}`"
                    >
                      <template v-for="(part, index) in group.pathParts" :key="`product-cat-part-${product.id}-${groupIndex}-${index}`">
                        <span :class="['product-category-level', index === 0 ? 'product-category-main' : 'product-category-sub']">{{ part }}</span>
                        <span v-if="index < group.pathParts.length - 1" class="product-category-arrow">›</span>
                      </template>
                      <span v-if="group.leafLabels.length && group.pathParts.length" class="product-category-arrow">›</span>
                      <template v-for="(leaf, leafIndex) in group.leafLabels" :key="`product-cat-leaf-${product.id}-${groupIndex}-${leafIndex}`">
                        <span class="product-category-level product-category-sub product-category-extra">{{ leaf }}</span>
                      </template>
                    </div>
                  </div>
                </v-card-text>
              </v-card-item>
            </div>
            <div @click.stop>
              <add-to-cart :product="product" @dialog-visibility-change="handleCartDialogVisibility"></add-to-cart>
            </div>
          </v-card>
        </div>
        <v-pagination v-model="page" :length="totalPages"></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import {toast} from "vue3-toastify";
import Alert from "@/components/Alert";
import AddToCart from "@/components/AddToCart";
import { getProductPriceLabel as resolveProductPriceLabel, hasBottleSizePriceRange as productHasBottleSizePriceRange } from "@/utils/productOptions.js";

export default {
  name: "ProductView",
  components: {AddToCart, Alert, PageHeader},
  props: ['category'],
  data() {
    return {
      dialog: false,
      mobileOpenedGroups: [],
      desktopOpenedGroups: [],
      products: [],
      categories: [],
      cat: [],
      selectedCategory: sessionStorage.getItem('selectedCategory'),
      sortOption: sessionStorage.getItem('sortOption') || 'default',
      quantity: 1,
      isCartDialogOpen: false,
      hoveredProducts: {},
      hoverTimers: {},
      page: Number(sessionStorage.getItem('currentPageProducts')) || 1,
      perPage: Number(sessionStorage.getItem('perPage')) || 10,
      perPageOptions: [10, 16, 20],
      search: sessionStorage.getItem('search') || '',
      eshopPopupVisible: false,
      eshopPopupMessage: "",
      eshopPopupImage: "",
    };
  },
  computed: {
    cartItemCount() {
      return this.$store.getters.cartItemCount;
    },
    cart() {
      return this.$store.state.cart;
    },
    isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
    getCategories() {
      let categories;
      if (this.$i18n.locale === 'en') {
        categories = this.categories.map(category => ({ key: category.name, value: category.name_en ? category.name_en : category.name }));
      }
      else if (this.$i18n.locale === 'ru') {
        categories = this.categories.map(category => ({ key: category.name, value: category.name_ru ? category.name_ru : category.name }));
      }
      else {
        categories = this.categories.map(category => ({ key: category.name, value: category.name }));
      }
      return categories;
    },
    groupedCategories() {
      const result = [];
      const groupIndex = new Map();

      this.getCategories.forEach((category) => {
        const keyParts = (category.key || '').split(' - ').map((part) => part.trim()).filter(Boolean);
        const valueParts = (category.value || '').split(' - ').map((part) => part.trim()).filter(Boolean);

        if (keyParts.length > 1) {
          const groupKey = keyParts[0];
          const groupLabel = valueParts.length > 1 ? valueParts[0] : groupKey;

          if (!groupIndex.has(groupKey)) {
            result.push({
              type: 'group',
              groupKey,
              groupLabel,
              items: [],
            });
            groupIndex.set(groupKey, result.length - 1);
          }

          const currentGroup = result[groupIndex.get(groupKey)];

          if (keyParts.length === 2) {
            const childLabel = valueParts[1] || keyParts[1];
            currentGroup.items.push({
              type: 'leaf',
              key: category.key,
              value: childLabel,
            });
            return;
          }

          const subGroupKey = `${keyParts[0]} - ${keyParts[1]}`;
          const subGroupLabel = valueParts[1] || keyParts[1];
          const subChildLabel = valueParts.slice(2).join(' - ') || keyParts.slice(2).join(' - ');

          let subGroup = currentGroup.items.find((item) => item.type === 'group' && item.key === subGroupKey);
          if (!subGroup) {
            subGroup = {
              type: 'group',
              key: subGroupKey,
              value: subGroupLabel,
              items: [],
            };
            currentGroup.items.push(subGroup);
          }

          subGroup.items.push({
            key: category.key,
            value: subChildLabel,
          });
          return;
        }

        result.push({
          type: 'single',
          key: category.key,
          value: category.value,
        });
      });

      return result;
    },
    hasGroupedCategories() {
      return this.groupedCategories.some((entry) => entry.type === 'group');
    },
    groupedCategoryIdMap() {
      const map = {};

      this.categories.forEach((category) => {
        const parts = (category.name || '').split(' - ').map((part) => part.trim()).filter(Boolean);
        if (parts.length > 1) {
          const groupSlug = this.slugifyCategory(parts[0]);
          if (!map[groupSlug]) {
            map[groupSlug] = [];
          }
          map[groupSlug].push(category.id);

          if (parts.length > 2) {
            const subGroupSlug = this.slugifyCategory(`${parts[0]} - ${parts[1]}`);
            if (!map[subGroupSlug]) {
              map[subGroupSlug] = [];
            }
            map[subGroupSlug].push(category.id);
          }
        }
      });

      return map;
    },
    paginatedPosts() {
      const start = (this.page - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredProducts.slice(start, end);
    },
    filteredProducts() {
      let products;
      let category;
      if (this.categories) category = this.categories.find(cat => this.slugifyCategory(cat.name) === this.category);
      if (this.category && category) {
        products = this.products.filter(product => this.getProductCategoryIds(product).includes(Number(category.id)));
      }
      else if (this.category && this.groupedCategoryIdMap[this.category]) {
        products = this.products.filter(product => {
          const productCategoryIds = this.getProductCategoryIds(product);
          return productCategoryIds.some((id) => this.groupedCategoryIdMap[this.category].includes(id));
        });
      }
      else {
        products = this.products;
      }
      // Filter products based on search term
      products = products.filter(product =>
          (product.header && product.header.toLowerCase().includes(this.search)) ||
          (product.header && product.header.includes(this.search)) ||
          (product.header_en && product.header_en.toLowerCase().includes(this.search)) ||
          (product.header_en && product.header_en.includes(this.search)) ||
          (product.header_ru && product.header_ru.toLowerCase().includes(this.search)) ||
          (product.header_ru && product.header_ru.includes(this.search))
      );
      if (this.sortOption === 'price-asc') {
        products.sort((a, b) => a.price - b.price);
      } else if (this.sortOption === 'price-desc') {
        products.sort((a, b) => b.price - a.price);
      }
      return products;
    },
    totalPages() {
      return Math.ceil(this.filteredProducts.length / this.perPage);
    },
    totalProducts() {
      return this.products.length;
    },
    itemsPerPage() {
      return this.paginatedPosts.length;
    },
    sortOptions() {
      return [
        { text: this.$t('uuemad'), value: 'default' },
        { text: this.$t('odavamad'), value: 'price-asc' },
        { text: this.$t('kallimad'), value: 'price-desc' }
      ]
    },
    popupBackgroundStyle() {
      const image = this.eshopPopupImage;
      if (!image) {
        return {
          background: 'linear-gradient(135deg, #f5f8ff 0%, #e8efff 100%)',
        };
      }

      return {
        backgroundImage: `url(${image})`,
      };
    }
  },
  methods: {
    hasBottleSizePriceRange(content) {
      return productHasBottleSizePriceRange(content);
    },
    getPriceLabel(content, size) {
      return resolveProductPriceLabel(content, size);
    },
    getProductCategoryIds(content) {
      if (!content) return [];

      if (Array.isArray(content.category_ids)) {
        return content.category_ids.map((value) => Number(value)).filter((value) => Number.isFinite(value));
      }

      return [];
    },
    slugifyCategory(value) {
      const parts = String(value || '')
          .split(' - ')
          .map((part) => part.trim())
          .filter(Boolean);

      const slugifyPart = (part) => part
          .toLowerCase()
          .replace(/[ä]/g, 'a')
          .replace(/[öõ]/g, 'o')
          .replace(/[ü]/g, 'u')
          .replace(/\s+/g, '-')
          .replace(/[^a-z0-9-]/g, '')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '');

      return parts.map(slugifyPart).filter(Boolean).join('/');
    },
    isCategoryActive(slug) {
      return this.category === slug;
    },
    goToMobileCategory(slug) {
      this.dialog = false;
      if (!slug) {
        this.clearCategoryFilter();
        return;
      }
      this.$router.push(`/tooted/${slug}`);
    },
    clearCategoryFilter() {
      this.mobileOpenedGroups = [];
      this.desktopOpenedGroups = [];
      this.$router.push('/tooted');
    },
    fetchProducts() {
      fetch(`${process.env.VUE_APP_SERVER_URL}/api/products`)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Failed to load products: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            const normalizedProducts = Array.isArray(data) ? data : [];
            this.originalProducts = [...normalizedProducts].sort((a, b) => Number(b.id) - Number(a.id));
            this.products = [...this.originalProducts];
          })
          .catch((err) => {
            console.log(err.message);
            this.originalProducts = [];
            this.products = [];
          });
    },
    fetchCats() {
      fetch(`${process.env.VUE_APP_SERVER_URL}/api/categories`)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Failed to load categories: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            this.categories = Array.isArray(data) ? data : [];
            this.syncMobileOpenedGroups();
            this.syncDesktopOpenedGroups();
          })
          .catch((err) => {
            console.log(err.message);
            this.categories = [];
          });
    },
    getActiveGroupKeys() {
      if (!this.category) {
        return [];
      }

      if (this.groupedCategoryIdMap[this.category]) {
        const groupEntry = this.groupedCategories.find((entry) => {
          if (entry.type !== 'group') {
            return false;
          }

          if (this.slugifyCategory(entry.groupKey) === this.category) {
            return true;
          }

          return entry.items.some(
              (child) => child.type === 'group' && this.slugifyCategory(child.key) === this.category
          );
        });

        if (!groupEntry) {
          return [];
        }

        const subGroupEntry = groupEntry.items.find(
            (child) => child.type === 'group' && this.slugifyCategory(child.key) === this.category
        );

        return subGroupEntry ? [groupEntry.groupKey, subGroupEntry.key] : [groupEntry.groupKey];
      }

      const currentCategory = this.categories.find((category) => this.slugifyCategory(category.name) === this.category);
      if (!currentCategory) {
        return [];
      }

      const parts = (currentCategory.name || '').split(' - ').map((part) => part.trim()).filter(Boolean);
      if (parts.length > 2) {
        return [parts[0], `${parts[0]} - ${parts[1]}`];
      }

      if (parts.length > 1) {
        return [parts[0]];
      }

      return [];
    },
    syncMobileOpenedGroups() {
      this.mobileOpenedGroups = this.getActiveGroupKeys();
    },
    syncDesktopOpenedGroups() {
      this.desktopOpenedGroups = this.getActiveGroupKeys();
    },
    increaseQuantity() {
      this.quantity++;
    },
    decreaseQuantity() {
      if (this.quantity > 1) {
        this.quantity--;
      }
    },
    addToCart(product) {
      this.$store.dispatch('addToCart', {
        product: product,
        quantity: this.quantity,
        choice: 'Spray',
        size: '100ml',
      });
      this.quantity = 1;
    },
    showToastSuccess(value) {
      toast.success(value, {
        autoClose: 3000
      })
    },
    getHeader(content) {
      return (this.$i18n.locale === 'en' && content.header_en !== null) ? content.header_en : (this.$i18n.locale === 'ru' && content.header_ru !== null) ? content.header_ru : content.header;
    },
    getProductImages(content) {
      const image = content?.image;

      if (!image) return [];

      if (Array.isArray(image)) {
        return image.filter(Boolean);
      }

      if (typeof image === 'string') {
        const trimmed = image.trim();
        if (!trimmed) return [];

        if (trimmed.startsWith('[')) {
          try {
            const parsed = JSON.parse(trimmed);
            return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
          } catch (err) {
            console.log(err);
          }
        }

        if (trimmed.startsWith('{') && trimmed.endsWith('}')) {
          return trimmed
              .slice(1, -1)
              .split(',')
              .map((value) => value.replace(/^"|"$/g, '').trim())
              .filter(Boolean);
        }

        return [trimmed];
      }

      return [];
    },
    getCategoryLabelById(categoryId) {
      const category = this.categories.find((cat) => cat.id === categoryId);
      if (!category) return '';

      const categoryName = (this.$i18n.locale === 'en' && category.name_en !== null)
          ? category.name_en
          : (this.$i18n.locale === 'ru' && category.name_ru !== null)
              ? category.name_ru
              : category.name;

      return String(categoryName || '').trim();
    },
    getCategoryBreadcrumbParts(categoryId) {
      const categoryLabel = this.getCategoryLabelById(categoryId);
      if (!categoryLabel) return [];

      return categoryLabel
          .split(' - ')
          .map((part) => part.trim())
          .filter(Boolean);
    },
    getProductCategoryGroups(content) {
      const categoryPaths = this.getProductCategoryIds(content)
          .map((categoryId) => this.getCategoryBreadcrumbParts(categoryId))
          .filter((parts) => parts.length);

      const uniqueCategoryPaths = [];
      categoryPaths.forEach((pathParts) => {
        const pathKey = pathParts.join(' - ');
        if (!uniqueCategoryPaths.some((entry) => entry.pathKey === pathKey)) {
          uniqueCategoryPaths.push({ pathKey, pathParts });
        }
      });

      const groupedPaths = [];

      uniqueCategoryPaths.forEach(({ pathParts }) => {
        const groupKey = pathParts.slice(0, -1).join(' - ') || pathParts[0];
        let group = groupedPaths.find((entry) => entry.groupKey === groupKey);
        if (!group) {
          group = {
            groupKey,
            paths: [],
          };
          groupedPaths.push(group);
        }

        group.paths.push(pathParts);
      });

      return groupedPaths.map((group) => {
        const commonPrefix = group.paths.reduce((prefix, pathParts) => {
          if (!prefix.length) return pathParts.slice();

          let index = 0;
          while (index < prefix.length && index < pathParts.length && prefix[index] === pathParts[index]) {
            index += 1;
          }

          return prefix.slice(0, index);
        }, []);

        const pathParts = commonPrefix.length ? commonPrefix : group.paths[0];
        const leafLabels = [];

        group.paths.forEach((pathPartsItem) => {
          const suffixParts = pathPartsItem.slice(pathParts.length).filter(Boolean);
          const leaf = suffixParts.join(' › ');
          if (leaf && !leafLabels.includes(leaf)) {
            leafLabels.push(leaf);
          }
        });

        return {
          pathParts,
          leafLabels,
        };
      }).filter((group) => group.pathParts.length || group.leafLabels.length);
    },
    getLinkCat(content) {
      return this.$store.getters.getLinkCat(content);
    },
    getCat(content) {
      let id = Array.isArray(content?.category_ids) ? content.category_ids[0] : null;
      let category = this.categories.find(cat => cat.id === id);
      if (!category) return '';

      const categoryName = (this.$i18n.locale === 'en' && category.name_en !== null)
          ? category.name_en
          : (this.$i18n.locale === 'ru' && category.name_ru !== null)
              ? category.name_ru
              : category.name;

      const parts = String(categoryName || '')
          .split(' - ')
          .map((part) => part.trim())
          .filter(Boolean);

      return parts[parts.length - 1] || '';
    },
    getCatParts(content) {
      if (!content) return [];
      return this.getProductCategoryGroups(content).flatMap((group) => [
        ...group.pathParts,
        ...group.leafLabels,
      ]);
    },
    isProductHovered(productId) {
      return Boolean(this.hoveredProducts[productId]);
    },
    clearHoverTimer(productId) {
      const existingTimer = this.hoverTimers[productId];
      if (existingTimer) {
        clearTimeout(existingTimer);
      }
    },
    queueHoverState(productId, nextState, delayMs) {
      this.clearHoverTimer(productId);

      const timer = setTimeout(() => {
        this.hoveredProducts = {
          ...this.hoveredProducts,
          [productId]: nextState,
        };
      }, delayMs);

      this.hoverTimers = {
        ...this.hoverTimers,
        [productId]: timer,
      };
    },
    setImageHover(productId, isHovering) {
      if (isHovering) {
        this.queueHoverState(productId, true, 100);
        return;
      }

      this.queueHoverState(productId, false, 60);
    },
    openProduct(product) {
      const category = this.getLinkCat(product);
      if (category) {
        this.$router.push(`/tooted/${category}/${product.id}`);
      }
    },
    handleProductCardClick(product) {
      if (this.isCartDialogOpen) {
        return;
      }

      this.openProduct(product);
    },
    handleCartDialogVisibility(value) {
      this.isCartDialogOpen = value;
    },
    parseTextImage(image) {
      if (!image) return "";

      if (Array.isArray(image)) {
        const first = image.find((value) => typeof value === 'string' && value.trim() !== '');
        return first || '';
      }

      if (typeof image === 'string') {
        const trimmed = image.trim();
        if (!trimmed) return '';

        if (trimmed.startsWith('{') && trimmed.endsWith('}')) {
          return trimmed
              .slice(1, -1)
              .split(',')
              .map((value) => value.replace(/^"|"$/g, '').trim())
              .find(Boolean) || '';
        }

        return trimmed;
      }

      return '';
    },
    hasPopupContent(message, image) {
      const plain = String(message || '')
          .replace(/<[^>]*>/g, ' ')
          .replace(/&nbsp;/g, ' ')
          .trim();
      return plain.length > 0 || Boolean(image);
    },
    closeEshopPopup() {
      this.eshopPopupVisible = false;
      sessionStorage.setItem('eshopPopupSeen', '1');
    },
    async fetchEshopPopup() {
      try {
        const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/api/texts/11`);
        if (response.status === 404) {
          this.eshopPopupMessage = "";
          this.eshopPopupImage = "";
          this.eshopPopupVisible = false;
          return;
        }

        if (!response.ok) {
          throw new Error("Failed to load popup text");
        }

        const data = await response.json();
        const message = ((this.$i18n.locale === 'en' && data?.body_en) ? data.body_en : (this.$i18n.locale === 'ru' && data?.body_ru) ? data.body_ru : data?.body) || "";
        const image = this.parseTextImage(data?.image);

        this.eshopPopupMessage = String(message || '');
        this.eshopPopupImage = image;

        const alreadySeen = sessionStorage.getItem('eshopPopupSeen') === '1';
        this.eshopPopupVisible = this.hasPopupContent(this.eshopPopupMessage, this.eshopPopupImage) && !alreadySeen;
      } catch (err) {
        this.eshopPopupMessage = "";
        this.eshopPopupImage = "";
        this.eshopPopupVisible = false;
      }
    }
  },
  mounted() {
    this.fetchProducts();
    this.fetchCats();
    this.fetchEshopPopup();
    try {
      const savedCart = localStorage.getItem('cart');
      if (savedCart) {
        const parsedCart = JSON.parse(savedCart);
        if (parsedCart && typeof parsedCart === 'object') {
          this.$store.commit('loadCart', parsedCart);
        }
      }
    } catch (error) {
      console.log('Failed to restore cart:', error?.message || error);
      localStorage.removeItem('cart');
    }
  },
  watch: {
    category: {
      immediate: true,
      handler(newVal, oldVal) {
        if (oldVal !== undefined && newVal !== oldVal) {
          this.page = 1;
          sessionStorage.setItem('currentPageProducts', 1);
        }
        this.syncMobileOpenedGroups();
        this.syncDesktopOpenedGroups();
      },
    },
    page(newPage) {
      sessionStorage.setItem('currentPageProducts', newPage);
      this.$nextTick(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      });
    },
    perPage(newPageNr) {
      sessionStorage.setItem('perPage', newPageNr);
      this.dialog = false;
    },
    sortOption(newSortOption) {
      sessionStorage.setItem('sortOption', newSortOption);
      this.dialog = false;
    },
    selectedCategory(newValue) {
      let newCategory = this.categories.find(category => category.name === newValue)?.name;
      if (newCategory === undefined) {
        location.assign("/tooted");
        sessionStorage.removeItem('selectedCategory');
      }
      else {
        location.assign(`/tooted/${this.slugifyCategory(newCategory)}`);
        sessionStorage.setItem('selectedCategory', newCategory);
      }
      this.dialog = false;
    },
    search(newSearchOption) {
      sessionStorage.setItem('search', newSearchOption);
    },
    categories() {
      this.syncMobileOpenedGroups();
      this.syncDesktopOpenedGroups();
    },
    '$i18n.locale'() {
      this.fetchEshopPopup();
    },
  },
  created() {
    this.currentCategory = sessionStorage.getItem('currentCategory') || 'Uuemad tooted';
    this.$store.dispatch('fetchProducts');
    this.$store.dispatch('fetchCategories');
  },
  beforeUnmount() {
    Object.values(this.hoverTimers).forEach((timer) => clearTimeout(timer));
    sessionStorage.removeItem('selectedCategory');
  },
}
</script>


<style scoped>
.product-img {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 220px;
  overflow: hidden;
}

.eshop-popup-card {
  overflow: hidden;
}

.eshop-popup-bg {
  position: relative;
  min-height: 360px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.eshop-popup-overlay {
  position: absolute;
  inset: 0;
  padding: 28px;
  background: rgba(14, 23, 41, 0.35);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.eshop-popup-close {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  background: transparent !important;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.eshop-popup-text {
  font-size: 17px;
  line-height: 1.6;
}

.eshop-popup-text :deep(p) {
  margin: 0 0 10px 0;
}

.eshop-popup-text :deep(*) {
  color: inherit;
}

.carousel-image {
  width: 100%;
  height: 100%;
}

.product-layered-images {
  position: relative;
  width: 100%;
  height: 100%;
}

.base-image,
.hover-image {
  position: absolute;
  inset: 0;
  transition: opacity 320ms cubic-bezier(0.22, 0.61, 0.36, 1);
  will-change: opacity;
}

.base-image {
  opacity: 1;
}

.base-image.is-inactive {
  opacity: 0;
}

.hover-image {
  opacity: 0;
}

.hover-image.is-active {
  opacity: 1;
}

.carousel-image :deep(.v-responsive) {
  height: 100%;
}

.carousel-image :deep(.v-img__img) {
  object-fit: contain !important;
  object-position: center center !important;
}

img {
  margin: auto;
}

.product-img .default-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.filter-items:hover {
  color: #3b71f7;
}

.prod-item img {
  width: 100%;
  display: block;
}

.product {
  display: flex;
  flex-wrap: wrap;
}

.product--dialog-open .prod-item {
  pointer-events: none;
}

.prod-item {
  display: flex;
  flex-direction: column;
  width: 25%;
}

.prod-item--dialog-open {
  cursor: default;
}

.head {
  white-space: normal;
  font-size: 20px;
}

.mobile-filters {
  display: none;
}

.sidebar {
  width: 300px;
  min-width: 300px;
  flex-shrink: 0;
}

.sidebar-list {
  border: 1px solid #e6e6e6;
  border-radius: 12px;
  background: #fafafa;
  padding: 8px;
}

.category-group-header {
  background: #f1f5ff;
  border-radius: 8px;
}

.category-child {
  border-left: 2px solid #d9e6ff;
  margin-left: 8px;
}

.category-all {
  font-weight: 400;
}

.category-single {
  border-radius: 8px;
}

.product-filters a:hover {
  color: #3b71f7;
}

.prices {
  display: inline-flex;
  flex-direction: row;
}

.product-category-text {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
  line-height: 1.2;
}

.product-category-group {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  margin-bottom: 6px;
}

.product-category-level {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.product-category-pill {
  font-size: 14px;
  font-weight: 700;
  color: #1f2d3d;
  letter-spacing: 0.01em;
  background: #eef4ff;
  border: 1px solid #dbe8ff;
  border-radius: 999px;
  padding: 3px 9px;
}

.product-category-arrow {
  color: #93a1b2;
  font-size: 12px;
  font-weight: 700;
}

.product-category-main {
  font-size: 14px;
  font-weight: 700;
  color: #1f2d3d;
  background: #eef4ff;
  border: 1px solid #dbe8ff;
  border-radius: 999px;
  padding: 3px 9px;
}

.product-category-sub {
  font-size: 13px;
  font-weight: 400;
  color: #5d6b7a;
  background: #f7f9fc;
  border: 1px solid #e7edf6;
  border-radius: 999px;
  padding: 3px 9px;
}

.product-category-extra {
  margin-left: 4px;
}

.product-link {
  flex-grow: 1;
}

.v-list-group__items .v-list-item {
    padding-inline-start: 12px !important;
}


.sidebar :deep(.v-list-item-title) {
  white-space: nowrap !important;
  overflow: visible !important;
  text-overflow: unset !important;
}

.sidebar :deep(.v-list-item),
.sidebar :deep(.v-list-item__content) {
  overflow: visible !important;
}

.category-group-header :deep(.v-list-item-title),
.category-single :deep(.v-list-item-title) {
  font-weight: 700;
}

.category-child :deep(.v-list-item-title) {
  font-weight: 400;
}

.mobile-category-group-header :deep(.v-list-item-title),
.mobile-category-single-header :deep(.v-list-item-title) {
  font-weight: 700;
}

.mobile-category-child :deep(.v-list-item-title) {
  font-weight: 400;
}

@media (max-width: 1200px) {
  .prod-item {
    width: 33.3%;
  }
  .product-img {
    height: 200px !important;
  }
}

@media (max-width: 1000px) {
  .sidebar {
    display: none;
  }
  .mobile-filters {
    display: flex;
  }
  .pc-filters {
    display: none !important;
  }
  .content-divider {
    display: none;
  }
}

@media (max-width: 820px) {
  .prod-item {
    width: 50%;
  }
  .product-img {
    height: 250px !important;
  }
}

@media (max-width: 599px) {
  .prod-item {
    width: 100%;
  }
  .product-img {
    height: 250px;
    width: 100%;
  }
}
</style>
